const times = {
    statuses: {
        DRAFT: 'draft',
        MANUAL: 'manual',
        AUTOMATIC: 'automatic',
        VERIFIED: 'verified',
        STAMPED: 'stamped',
        SYSTEM: 'system',
        AUTOLOGOUT: 'auto-logout',
        NOTASKLOC: 'no-task-loc',
        MOBILE: 'Mobile',
        WEB: 'Web',
    },
    getStatusByGps: timelog => {
        if (timelog.status === 'draft') return times.statuses.DRAFT;
        if (timelog.auto_logout) return times.statuses.AUTOLOGOUT;
        if (!timelog.gps_data) return times.statuses.MANUAL;
        const { start, end, task } = timelog.gps_data || {};
        if (!task) return times.statuses.NOTASKLOC;
        if (!start || !end || start.manual || end.manual) return times.statuses.MANUAL;
        if (start && start.cron && end && end.cron) return times.statuses.AUTOMATIC;
        return times.statuses.VERIFIED;
    },
};
export default times;
